
const inlineConfig = {
  "nuxt": {},
  "sentry": {
    "config": {
      "release": "baserow-saas-web-frontend@2.4.1@0.2.324@3a8582fa-412a-42c7-847e-b02d1c500e4c",
      "ignoreErrors": [
        "ResizeObserver loop limit exceeded",
        "ResizeObserver loop completed with undelivered notifications",
        "undefined is not an object (evaluating 'document.getElementsByTagName('video')[0].webkitExitFullScreen')",
        "Failed to fetch dynamically imported module",
        "error loading dynamically imported module"
      ],
      "denyUrls": [
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {},
        {}
      ]
    }
  }
}

/** client **/
import { _replaceAppConfig } from '#app/config'

// Vite - webpack is handled directly in #app/config
if (import.meta.dev && !import.meta.nitro && import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    if (newModule) {
      _replaceAppConfig(newModule.default)
    }
  })
}
/** client-end **/



export default inlineConfig
